/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CalculateVatModel } from '../../models/calculate-vat-model';
import { Response } from '../../models/response';

export interface ApiCartCartCalculatevatPost$Params {
      body?: CalculateVatModel
}

export function apiCartCartCalculatevatPost(http: HttpClient, rootUrl: string, params?: ApiCartCartCalculatevatPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Response>> {
  const rb = new RequestBuilder(rootUrl, apiCartCartCalculatevatPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Response>;
    })
  );
}

apiCartCartCalculatevatPost.PATH = '/api/cart/cart/calculatevat';
